<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div>
          <div style="margin-bottom: 3px;">1.仅支持上传zip格式压缩包，需要把导入的考生照片放在一个文件夹打包压缩；</div>
          <div style="margin-bottom: 3px;">2.考生的证件照命名规则【使用报名时的“证件号码”】命名，若证件号码有字母则需要用大写，考生的证件照可以是png、jpg、jpeg格式，图片大小10k~2M之间；</div>
          <div style="margin-bottom: 10px;">3.压缩包大小1k~100M之间。</div>
          <el-form-item label="选择文件" prop="fileUrl" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-upload class="inline-block" action="" :http-request="uploadOSS" :show-file-list="false" accept=".zip,.rar">
              <el-button type="default" style="color: #1890FF;margin-left: 0px;">导入证件照</el-button>
            </el-upload>
            <el-progress v-if="!Tool.isNull(form.fileUrlProcess)" :percentage="Tool._toFixed(form.fileUrlProcess*100,0)"></el-progress>
            <el-input class="none" type="text" v-model="form.fileUrl" :maxlength="1024"></el-input>
            <div v-if="form.fileUrl">
              <div class="border inline-block" style="margin-top: 10px;">
                <i class="icon icon_explain pointer" style="font-size: 30px;"></i>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null,
      batchList: []
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS (event) {
      try {
        if (event.file.size > 1024 * 1024 * 100) {
          throw new Error('仅支持zip格式图片文件，且文件大小在1k~100M之间')
        }
        if (event.file.size < 1024 * 1) {
          throw new Error('仅支持zip格式图片文件，且文件大小在1k~100M之间')
        }
        this.form.fileUrl = await this.$HTTP.ApiOss.uploadOSS(event.file, `importExam`, '.zip', 'temp', (p) => {
          this.form.fileUrlProcess = p
          this.$forceUpdate()
        })
        this.$forceUpdate()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async initForm () {
      this.batchList = await this.$HTTP.ApiBatch.getList()
      console.log(this.batchList);
      if (this.Tool.isNull(this.batchList)) {
        throw new Error('没有考试数据')
      }
      if (!this.Tool.isNull(this.row)) {
        let info = JSON.parse(JSON.stringify(this.row))
        info.fileUrl = ''
        info.taskName = 'import_official_photo'
        this.form = info
      } else {
        this.form = {
          fileUrl: '',
          taskName: 'import_official_photo',
          batchId: this.batchList[0].batchId
        }
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        await this.$HTTP.ApiExamOnline.importOfficialPhoto({
          importType: 1,
          fileUrl: this.form.fileUrl
        })
        this.$emit('close', this.form)
      }
    }
  }
}
</script>
